var $ = jQuery;

function init() {
  const $links = $('.microsite-main-nav__links li a');
  const $trigger = $('.microsite-main-nav__trigger');
  const $target = $('.microsite-main-nav');

  if($('.microsite-one-pager')) {
    binds();
  }

  function binds() {
    $links.on('click', scrollToSection);
    $trigger.on('click', toggleNav);
  }

  function toggleNav() {
    $target.toggleClass('_active');
  }


  function scrollToSection(e) {
    e.preventDefault();
    let anchor = $(this).attr('href');

    $target.toggleClass('_active');

    $('html, body').animate({
      scrollTop: $(anchor).offset().top - 80
    }, 200);
  }
}

export {init as init};
